import React, { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Loader from "../../components/Loader";
import api from "../../configs/api";
import { showSuccess, showError } from "../../utils/toastUtils";
import loginBg from "../../assets-user/login/hero_bg.png";

const SuperAdminLogin = () => {
  const { adminUser, hydrated, setAdminUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (!hydrated) return <Loader />;

  if (adminUser && adminUser.role === "super-admin") {
    return <Navigate to="/super-admin" replace />;
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await api.post("/admin-auth/login", { email, password });

      if (res.data?.user && res.data?.token) {
        setAdminUser(res.data.user);
        localStorage.setItem("adminData", JSON.stringify(res.data.user));
        localStorage.setItem("adminToken", res.data.token);
        showSuccess("Admin logged in successfully");
        navigate("/super-admin");
      }
    } catch (err) {
      showError(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <div
        style={{ backgroundImage: `url(${loginBg})` }}
        className="flex-1 relative bg-cover bg-center flex flex-col md:flex-row items-center w-full px-4 md:px-8 lg:px-10 z-10"
      >
        <div className="absolute inset-0 bg-black/70 z-20"></div>

        <div className="container mx-auto py-8 lg:py-12 z-30">
          <div className="grid grid-cols-1 lg:grid-cols-10 gap-8 lg:gap-12 items-center">

            {/* Left Side text */}
            <div className="text-white lg:col-span-6 space-y-4 lg:space-y-6">
              <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-200">
                Welcome to LeadBook Admin
              </p>
              <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold leading-tight sm:leading-tight lg:leading-[1.1] tracking-wide">
                Manage Users, Properties & Leads.
              </h1>
            </div>

            {/* Right side form */}
            <div className="lg:col-span-4 mt-8 lg:mt-0">
              <div className="bg-white rounded-[20px] p-6 sm:p-8 shadow-2xl relative w-full max-w-md mx-auto">
                <div className="text-center mb-6 sm:mb-8">
                  <h2 className="text-2xl sm:text-[28px] font-bold text-gray-800 font-poppins">
                    Admin Login
                  </h2>
                </div>
                <form className="space-y-5" onSubmit={handleLogin}>
                  <div>
                    <label className="block text-left text-sm font-semibold text-gray-700 mb-2 font-poppins">
                      Email Address <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      required
                      placeholder="admin@gmail.com"
                      className="w-full px-4 py-3 sm:py-3.5 border border-gray-200 rounded-xl focus:outline-none focus:ring-1 focus:border-[#fc5c34] focus:ring-[#fc5c34] transition-colors"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          document.getElementById("passwordField").focus();
                        }
                      }}
                    />
                  </div>
                  <div>
                    <label className="block text-left text-sm font-semibold text-gray-700 mb-2 font-poppins">
                      Password <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="passwordField"
                      type="password"
                      required
                      placeholder="Enter your password"
                      className="w-full px-4 py-3 sm:py-3.5 border border-gray-200 rounded-xl focus:outline-none focus:ring-1 focus:border-[#fc5c34] focus:ring-[#fc5c34] transition-colors"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleLogin(e);
                        }
                      }}
                    />
                  </div>
                  <div className="pt-2">
                    <button
                      type="submit"
                      disabled={loading}
                      className="w-full bg-[#fc5c34] hover:bg-[#e04a25] text-white font-semibold py-3 sm:py-4 rounded-xl shadow-md transition-all transform hover:scale-[1.02] active:scale-[0.98]"
                    >
                      {loading ? "Logging in..." : "Continue"}
                    </button>
                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminLogin;
